module.exports = __webpack_public_path__ + "img/discovery-show.7a5807e2.png";